import { getTranslationHook } from '@coolblue-development/next-translations/client';
import config from './config.js';
export const useTranslation = getTranslationHook(config);
//# sourceMappingURL=useTranslation.js.map